module.exports = __webpack_public_path__ + "static/media/united-kingdom.db68882c.svg";